import { TRootState } from '../reducers';
import { ISolutionsState } from '../reducers/types';

export const selectSolutions = (state: TRootState): ISolutionsState['solutions'] => {
  return state.solutions.solutions;
};

export const selectSolutionsPaging = (state: TRootState): ISolutionsState['paging'] => {
  return state.solutions.paging;
};
